module.exports = __webpack_public_path__ + "img/gestionLignesCVP.1db156cf.jpg";